"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ParentChildrenLimitExceededError extends client_library_1.ExtendableError {
    constructor() {
        super('Parent children limit has been exceeded');
    }
}
exports.default = ParentChildrenLimitExceededError;
//# sourceMappingURL=ParentChildrenLimitExceededError.js.map